import React from 'react';
import { createRoot } from 'react-dom/client';
import { GoogleOAuthProvider } from '@react-oauth/google';
import App from "./App";
import './internal/iinc/iGlobal';
import './customer/cinc/cGlobal';

  // --- ONLINE --------------
  var hostName = window.location.hostname;
  // --- LOCALHOST --------------
  var currentURL = window.location.pathname;
  var arrPath = currentURL.split('/');

  var portalname = "";
  if(hostName === 'customers.point-star.com') { portalname = "customerportal"; }
  else if(hostName === 'internal.point-star.com') { portalname = "internalportal"; }
  else {
    if(arrPath[1] !== "") {
      if(arrPath[1].toLowerCase() === "customerportal") { portalname = "customerportal"; }
      else if(arrPath[1].toLowerCase() === "internalportal") { portalname = "internalportal"; }
      else {
        if(arrPath[1].toLowerCase().substring(0,1) === "c") { portalname = "customerportal"; }
        else if(arrPath[1].toLowerCase().substring(0,1) === "i") { portalname = "internalportal"; }
      }
    }
  }
  
const root = createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={portalname === "internalportal" ? global.config.credClientId : global.cconfig.credClientId2 } >
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
  
);